import { render } from "./OrderItemCardComponent.vue?vue&type=template&id=fa09ee78"
import script from "./OrderItemCardComponent.vue?vue&type=script&lang=js"
export * from "./OrderItemCardComponent.vue?vue&type=script&lang=js"

import "./OrderItemCardComponent.vue?vue&type=style&index=0&id=fa09ee78&lang=css"
script.render = render

export default script